import { AuditCard } from "@/features/Audit/AuditCard";
import i18n from "@/i18n";
import { useParams } from "react-router-dom";
import { MacroKeywordEditCard } from "./edit_card";

const client = "ia-quantilia";
const table_name = "macro_keywords";

export const MacroKeywordCard = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return <div>{i18n.t("errors.invalid_id")}</div>;
  }

  return (
    <div className="bg-gray-50 relative">
      <div className="flex flex-col gap-10 p-10">
        <MacroKeywordEditCard id={id} client={client} table_name={table_name} />
        <AuditCard id={id} client={client} audit_table_name={table_name} />
      </div>
    </div>
  );
};
